import { render, staticRenderFns } from "./AccountSettingsSecurity.vue?vue&type=template&id=210f08f5&scoped=true&"
import script from "./AccountSettingsSecurity.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsSecurity.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingsSecurity.vue?vue&type=style&index=0&id=210f08f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f08f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCol,VDivider,VForm,VRow,VTextField})
